interface AwsConfig {
  aws_region: string;
  aws_project_region: string;
  aws_user_pools_id: string;
  aws_user_pools_web_client_id: string;
  authenticationFlowType: string;
  aws_mandatory_sign_in: string;
}

const awsConfig: AwsConfig = {
  aws_region: 'eu-west-2',
  aws_project_region: 'eu-west-2',
  aws_user_pools_id: import.meta.env.VITE_USER_POOL_ID || 'eu-west-2_4qY1RZxpE',
  aws_user_pools_web_client_id: import.meta.env.VITE_USER_POOL_CLIENT_ID || '71aa7idbruo4pptjfk789kdfeh',
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  aws_mandatory_sign_in: 'enable'
};

export default awsConfig; 